/* global axios */

import ApiClient from './ApiClient';

class AiReplyPreferenceAPI extends ApiClient {
  constructor() {
    super('ai_reply_preference', { accountScoped: true });
  }

  get() {
    return axios.get(this.url);
  }

  update(data) {
    return axios.put(this.url, {
      ai_reply_preference: data,
    });
  }
}

export default new AiReplyPreferenceAPI();
